module.exports = __webpack_public_path__ + "static/media/play-background-4.e8a9d1eb.jpg";